import {TextSkeleton} from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import React from 'react';

import styles from './review.module.scss';

interface ReviewSkeletonProps {
    className?: string;
    isDesktopLayout?: boolean;
    inlineLayout?: boolean;
}

const MOBILE_MAX_LINES_IN_REVIEW = 8;
const DESKTOP_MAX_LINES_IN_REVIEW = 5;
export const ReviewSkeleton = ({
    className,
    isDesktopLayout = false,
    inlineLayout = false,
}: ReviewSkeletonProps) => {
    return (
        <div
            data-testid="review-skeleton"
            className={classNames(
                styles['review-container'],
                styles['no-vertical-borders'],
                className ?? null,
                {
                    [styles['review-desktop-container']]: isDesktopLayout,
                    [styles['review-desktop-inline']]: isDesktopLayout && inlineLayout,
                },
            )}
        >
            <TextSkeleton
                withTitle={true}
                lineCountPerParagraph={
                    isDesktopLayout ? DESKTOP_MAX_LINES_IN_REVIEW : MOBILE_MAX_LINES_IN_REVIEW
                }
            />
        </div>
    );
};
